import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createRenameTransformer } from '../common/utils';
import { DBSlackConfigSchema, SlackConfigSchema } from './schemas';

export const SlackConfigCodecConfig: TransformerConfig<
  typeof SlackConfigSchema,
  typeof DBSlackConfigSchema
> = {
  name: 'SlackConfig',
  clientSchema: SlackConfigSchema,
  dbSchema: DBSlackConfigSchema,
  transformers: [
    createRenameTransformer<typeof SlackConfigSchema, typeof DBSlackConfigSchema>(
      'slackUserId',
      'userId'
    ),
  ],
};

export const encodeSlackConfigToDb = createEncodeToDbFn(SlackConfigCodecConfig);
export const decodeSlackConfigFromDb = createDecodeFromDbFn(SlackConfigCodecConfig);
